import React, { useMemo } from 'react';
import { useSAData } from './useSAData';
import { ServerTable } from './ServerTable';
import { EXC_COLS } from './columns';
import { toneClass } from '@/components/po-grn/format';

export const ExceptionsTab = ({ params, onDrill }) => {
  const summaryParams = useMemo(() => ({ ...params, page_size: 1 }), [params]);
  const { data } = useSAData('/exceptions', summaryParams);
  const v = data?.validation;
  return (
    <div className="space-y-4">
      {v && (
        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3" data-testid="sa-validation">
          {[['Source line rows', v.source_rows], ['Distinct Invoice/DC numbers', v.distinct_documents], ['Invoice rows', v.invoice_rows],
            ['Delivery Challan rows', v.dc_rows], ['Sales rows (finalized invoices + dispatched DCs)', v.finalized_invoice_rows],
            ['Draft/Cancelled rows excluded', v.draft_cancelled_rows_excluded], ['Duplicate line candidates', v.duplicate_candidates]].map(([l, x]) => (
            <div key={l} className="rounded-lg border border-orange-100 bg-white px-3 py-2"><div className="text-[11px] text-stone-500">{l}</div>
              <div className="text-lg font-bold text-[#3b2416] tabular-nums">{Number(x).toLocaleString('en-IN')}</div></div>
          ))}
        </div>
      )}
      <div className="flex flex-wrap gap-2" data-testid="sa-exception-type-chips">
        {Object.entries(data?.by_severity || {}).map(([s, n]) => (
          <button key={s} type="button" onClick={() => onDrill({ tab: 'exceptions', patch: { severities: [s] } }, `Severity ${s}`)}
            className={`px-3 py-1 rounded-full border text-xs font-medium ${toneClass(s)}`} data-testid={`sa-exc-sev-${s}`}>{s}: {n}</button>
        ))}
        {Object.entries(data?.by_type || {}).sort((a, b) => b[1] - a[1]).map(([t, n]) => (
          <button key={t} type="button" onClick={() => onDrill({ tab: 'exceptions', patch: { exception_types: [t] } }, `Exception ${t}`)}
            className="px-3 py-1 rounded-full border border-orange-200 bg-white text-xs text-stone-700 hover:bg-orange-50" data-testid="sa-exc-type-chip">{t}: {n}</button>
        ))}
      </div>
      <div className="text-[11px] text-stone-500">Exceptions are auto-detected and read-only. Source values are shown unchanged; missing MRP or inward prices are never treated as zero; KG/KGS are not converted until unit equivalence is confirmed.</div>
      <ServerTable endpoint="/exceptions" params={params} columns={EXC_COLS} testId="sa-exceptions-table" itemKey="exception_id" />
    </div>
  );
};
